<div data-test="commercial-general-liability-form"
     [formGroup]="form()"
>
  <p-accordion data-test="commercial-general-liability-accordion"
               [multiple]="true"
               [value]="activePanels()"
               (valueChange)="onActivePanelsChange($event)"
  >
    <albert-sub-coverage-panels [activePanels]="activePanels()"
                                [form]="form()"
                                [isCreateMode]="isCreateMode()"
                                [mainIndex]="mainIndex()"
                                [memberExternalId]="memberExternalId()"
                                [panels]="panels"
                                [policyStatus]="policyStatus()"
    />
  </p-accordion>
</div>
